<template>
  <section class="section-confirm-bank-transfer content-padding-gray" v-if="order">
    <!-- Navigation -->
    <div class="row mb-3">
      <div class="col-12 col-lg-8 offset-lg-2">
        <router-link to="/my-reservations" class="text-primary-link">
          {{ $t('message.menu.my_reservations') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        <router-link class="text-primary-link" :to="`/reservation/${orderId}`">
          {{ $t('message.my_reservations.reservation_detail') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        {{ $t('message.my_reservations.payment') }}
      </div>
    </div>

    <!-- Complete payment -->
    <section v-if="order.paid_status === 1">
      <div class="row success-booking">
        <div class="col-12 col-lg-8 offset-lg-2">

          <div class="text-center p-2 text-center">
            <i class="fal fa-check-circle fa-5x -status-accepted"></i>
            <h2 class="pt-4 m-0">
              {{ order.order_summary_total.total | currency }}
            </h2>
          </div>

          <div class="card">
            <div class="card-body">
              <div>
                <b>{{ $t('message.qr_payment.payment_successful') }}</b>
              </div>
              <hr>
              <div class="row no-gutters pb-2">
                <div class="col-6">{{ $t('message.qr_payment.payment_method') }}</div>
                <div class="col-6 text-right">{{ $t('message.payment_method.promptpay') }}</div>
              </div>
              <div class="row no-gutters pb-2">
                <div class="col-6">{{ $t('message.qr_payment.transaction_date') }}</div>
                <div class="col-6 text-right">{{ order.order_summary_total.reconcile_date | prettyDate }}</div>
              </div>
              <div class="row no-gutters">
                <div class="col-6">{{ $t('message.qr_payment.order_id') }}</div>
                <div class="col-6 text-right">#{{ order.order_code }}</div>
              </div>
            </div>
          </div>

          <div class="pt-2">
            <router-link :to="'/reservation/'+order.id" tag="a" class="btn btn-info btn-block">
              {{ $t('message.booking.complete_step.view_my_booking') }}
            </router-link>
          </div>

        </div>
      </div>
    </section>
    <!-- Incomplete payment -->
    <section v-else>
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2">
          <div class="card" v-if="globalState">
            <div class="card-body">
              <h3 class="text-center py-2">{{ $t('message.bank_transfer.title') }}</h3>
              <span v-html="$options.filters.bankTransferDurationText(order, globalState)"></span>
              <div class="mt-3" v-if="order.selected_professional_id > 0">
                <img v-lazy="order.professional_picture" class="rounded-circle" width="40">
                &nbsp;{{ order.professional_name | firstName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2">
          <div class="card">
            <div class="card-body">
              <template v-if="order">
                <section class="mt-3">
                  <div class="text-left mt-4">
                    <order-summary-detail :order="order"/>
                  </div>
                  <order-summary-total-short :order="order"/>
                </section>
                <hr>
              </template>
              <section class="mt-4" v-if="order.paid_status === 0">
                <div class="row">
                  <div class="col-12 text-center">
                    <qr-code-payment ref="qrCodePayment" @checkQrPayment="checkQrPayment"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <hr>
                    <div class="text-remark">
                      {{ $t('message.promptpay.payment_remark') }}
                      <div class="pt-3 text-center">
                        <a href="https://line.me/R/ti/p/%40hnk7011n"
                           target="_blank"
                           class="btn btn-outline-info btn-block">
                          {{ $t('message.button.contact_admin') }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import OrderSummaryDetail from './OrderSummaryDetail'
  import OrderSummaryTotalShort from './components/OrderSummaryTotalShort'
  import QrCodePayment from '../qrPayment/QrCodePayment'
  import axios from 'axios'
  import insiderHelpers from '../../helpers/insiderHelpers'

  export default {
    components: {
      QrCodePayment,
      OrderSummaryDetail,
      OrderSummaryTotalShort
    },
    data () {
      return {
        checkingQrPayment: null,
        orderId: this.$route.params.id,
        qrResponse: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      })
    },
    watch: {
      order () {
        if (this.order && this.order.paid_status === 0) {
          setTimeout(() => {
            const qrPaymentData = {
              paymentFor: 'normal',
              orderId: this.orderId,
              amount: Number(this.order.order_summary_total.total)
            }
            this.$refs.qrCodePayment.loadQrCode(qrPaymentData)
          }, 250)
        }
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      async fetchOrderDetail () {
        await this.loadOrderDetail(this.orderId)
      },
      checkQrPayment (response) {
        this.qrResponse = response
        // Clear old interval before starting a new one
        if (this.checkingQrPayment !== null) {
          clearInterval(this.checkingQrPayment)
          this.checkingQrPayment = null
        }
        this.checkingQrPayment = setInterval(() => {
          const url = '/qr-payments'
          axios.get(url, {params: {transaction_code: this.qrResponse.partnerTxnUid}})
            .then(res => {
              const response = res.data
              if (!response.error) {
                if (response.qr_payment && response.qr_payment.status_code) {
                  if (response.qr_payment.status_code === '00') {
                    // Clear interval of qr payment
                    clearInterval(this.checkingQrPayment)
                    // Update paid data
                    this.fetchOrderDetail()
                    // Scroll to top
                    document.body.scrollTop = 0
                    document.documentElement.scrollTop = 0
                    // Insider purchase event case qr payment
                    const params = {
                      user: this.user,
                      orderId: this.orderId
                    }
                    insiderHelpers.purchaseEvent(params)
                  } else if (response.qr_payment.status_code === '10') {
                    clearInterval(this.checkingQrPayment)
                    const alertMessage = `Error: ${response.qr_payment.error_description}`
                    this.$swal({text: alertMessage, type: 'error'})
                    // if error set qr code timeout to be expired
                    this.$refs.qrCodePayment.finishTimer()
                  }
                }
              } else {
                clearInterval(this.checkingQrPayment)
              }
            })
            .catch(error => {
              console.log('error', error)
            })
        }, 7000)
      }
    },
    beforeDestroy () {
      clearInterval(this.checkingQrPayment)
    },
    mounted () {
      this.$store.commit('orderDetail/SET_ORDER_DETAIL', null)
      this.fetchOrderDetail()
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/order/ConfirmPromptpay.vue